import React, { useMemo } from 'react';

import { Highlighter, type MessageItemProps } from '@ergeon/core-components';

export const useSearchFilteredMessages = (
  messages: MessageItemProps[],
  searchText: string,
): MessageItemProps[] => {
  return useMemo(() => {
    // Filter messages based on search text
    const filtered = messages.filter((message) => {
      if (!searchText) return true;
      const messageText = typeof message.content === 'string' ? message.content : '';
      return messageText.toLowerCase().includes(searchText.toLowerCase());
    });

    // Wrap content in Highlighter when search text exists
    return filtered.map((message) => ({
      ...message,
      content:
        searchText && typeof message.content === 'string' ? (
          <Highlighter searchText={searchText}>{message.content}</Highlighter>
        ) : (
          message.content
        ),
    }));
  }, [messages, searchText]);
};
